import { renderIcon } from '../../SvgIcon.esm.js';

/******************************************************
 * This file was created by scripts/generate.js as part
 * of the build process. Do not edit this file directly.
 ******************************************************/
var iconType = {
  viewBox: "0 0 24 24",
  paths: [{
    d: "M20 8c1.1 0 2 .9 2 2v9c0 1.1-.9 2-2 2H7c-1.1 0-2-.9-2-2v-9c0-1.1.9-2 2-2zM9.6 2.44c.57-.28 1.24-.28 1.8.01l6.64 3.38c.43.23.73.7.79 1.17h-2.6L10.5 4 4 7.4V17c-1.1 0-2-.9-2-2V7.17c0-.53.32-1.08.8-1.34zM20 11.46c0-.67-.7-1.1-1.3-.79l-5.2 2.67-5.2-2.67c-.6-.31-1.3.12-1.3.79l.007.109a.8907.8907 0 00.483.681l5.61 2.88c.25.13.56.13.81 0l5.61-2.88c.29-.15.48-.46.48-.79z"
  }],
  circles: []
};
var MarkAsUnreadIcon = function MarkAsUnreadIcon(props) {
  return renderIcon(props, iconType);
};
export { MarkAsUnreadIcon };